import { Image,  Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import ContentCard from '../../../components/layout/ContentCard';
import AddRing from '../../../assets/Add_ring.png';
import BaseDialog from '../../../components/BaseDialog';
import CreateMailboxForm from '../forms/CreateMailboxForm';
import useCreateMailbox from '../hooks/useCreateMailbox';

const AddMailboxCard = () => {
    const [dialogOpen, setDialogOpen] = useState(false)

    const { createMailbox } = useCreateMailbox();

    return (
        <BaseDialog
            open={dialogOpen}
            setOpen={setDialogOpen}
            trigger={
                <ContentCard
                    width={380}
                    height={351}
                    background='brand.subtle'
                >
                    <VStack justifyContent='center' height={'100%'} cursor='pointer'>
                        <Image src={AddRing} width={135} height={135} />
                        <Text color='#C1C1C1' fontSize='2xl'>Add mailbox</Text>
                    </VStack>

                </ContentCard>
            }
            title={"Connect IMAP server"}
        >
            <CreateMailboxForm 
                onSubmit={createMailbox} 
                callback={() => setDialogOpen(false)}
            />
        </BaseDialog>
    )
}

export default AddMailboxCard;